import React, { useState } from "react";
import "./ContactForm.css";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [submitting, setSubmitting] = useState(false); 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await fetch("https://www.sreenathji.com/sendMail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      alert(result.message);

      
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false); 
    }
  };

  return (
    <section className="cform-wrapper">
      <h2 className="cform-title">Contact Us</h2>
      <form className="cform-grid" onSubmit={handleSubmit}>
        {/* First Name */}
        <div className="cform-group">
          <label htmlFor="firstName" className="cform-label">First Name</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            className="cform-input"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>

        {/* Last Name */}
        <div className="cform-group">
          <label htmlFor="lastName" className="cform-label">Last Name</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            className="cform-input"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>

        {/* Email */}
        <div className="cform-group">
          <label htmlFor="email" className="cform-label">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            className="cform-input"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        {/* Phone */}
        <div className="cform-group">
          <label htmlFor="phone" className="cform-label">Phone</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            className="cform-input"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>

        {/* Subject */}
        <div className="cform-group cform-full">
          <label htmlFor="subject" className="cform-label">Subject</label>
          <input
            type="text"
            id="subject"
            name="subject"
            className="cform-input"
            value={formData.subject}
            onChange={handleChange}
          />
        </div>

        {/* Message */}
        <div className="cform-group cform-full">
          <label htmlFor="message" className="cform-label">Message</label>
          <textarea
            id="message"
            name="message"
            className="cform-textarea"
            value={formData.message}
            onChange={handleChange}
            rows="5"
            required
          ></textarea>
        </div>

        {/* Submit Button */}
        <div className="cform-submit">
  <button type="submit" className="cform-button" disabled={submitting}>
    {submitting ? "Sending..." : "Send Message"}
  </button>
</div>
      </form>
    </section>
  );
}
